import { getLoginUserInfo } from "../../../utils/loginUser";
import { getHyphenedDate } from "../../../utils/utils";
import { isNullEmpty } from "../../../utils/validation";

const SALES_DETAIL_ROW_COUNT = 6;
const SALES_RESULTS_ROW_COUNT = 15;

const initialSalesResults = {
  isNew: true,
  salesDetailId: null,
  salesDetailNo: null,
  salesResultsId: null,
  unitPrice: null,
  buyerNo: null,
  quantity: null,
  containerShippingId: null,
  containerQuantity: 0,
  remarks: "",
  price: 0,
};

const initialSalesResultses = (
  startId = 1,
  quantity = SALES_RESULTS_ROW_COUNT
) => {
  const result = [];

  for (let i = 0; i < quantity; i++) {
    const newResult = {
      ...initialSalesResults,
      salesResultsId: startId + i,
      createdId: getLoginUserInfo().userId,
      updatedId: getLoginUserInfo().userId,
    };
    result.push(newResult);
  }

  return result;
};

const initialSalesDetail = {
  isNew: true,
  salesDetailId: null,
  salesDetailNo: null,
  rankId: null,
  productClassId: null,
  packingId: null,
  weight: null,
  quantity: 0,
  purchacePrice: 0,
  remarks: "",
};

const initialSalesDetails = (
  startId,
  startNo,
  quantity = SALES_DETAIL_ROW_COUNT
) => {
  const result = [];

  for (let i = 0; i < quantity; i++) {
    const newDetail = {
      ...initialSalesDetail,
      salesDetailId: startId + i,
      salesDetailNo: startNo + i,
      createdId: getLoginUserInfo().userId,
      updatedId: getLoginUserInfo().userId,
    };
    result.push(newDetail);
  }

  return result;
};

const initialSalesRecord = {
  isNewInvoice: false,
  salesRecordNo: "",
  salesRecordTypeCd: 1, // TODO Add Feature
  arrivalDate: getHyphenedDate(),
  fkey: null,
  productId: null,
  commodityOwnerCd: null,
  acceptanceEmployeeId: null,
  seriEmployeeId: null,
  acceptanceLabelNo: null,
  partition: null,
  originId: null,
  commodityMark: null,
  directorEmployeeId: null,
  containerShippingId: null,
  containerQuantity: 0,
  director: null,
  feeRate: 0,
  shippingFee: 0,
  depositFee: 0,
  salesRecordProcessDivisionCd: 0,
  modificationDate: "",
  deliveryDate: getHyphenedDate(),
  modificationDate: null,
  needsPrintForEachDetail: false,
  createdId: getLoginUserInfo().userId,
  updatedId: getLoginUserInfo().userId,
};

const getMaxSalesDetailId = (listSalesDetailInfo) => {
  if (!Array.isArray(listSalesDetailInfo) || listSalesDetailInfo.length === 0) {
    return 0; // Default to 1 if the array is empty or not provided
  }

  const allSalesDetailIds = listSalesDetailInfo.map(
    (item) => item.salesDetailId
  );
  return Math.max(...allSalesDetailIds) || 0;
};

const getMaxSalesDetailNo = (listSalesDetailInfo) => {
  if (!Array.isArray(listSalesDetailInfo) || listSalesDetailInfo.length === 0) {
    return 0; // Default to 1 if the array is empty or not provided
  }

  const allSalesDetailNos = listSalesDetailInfo.map(
    (item) => item.salesDetailNo
  );
  return Math.max(...allSalesDetailNos) || 0;
};

const getMaxSalesResultsId = (listSalesResultsInfo) => {
  if (
    !Array.isArray(listSalesResultsInfo) ||
    listSalesResultsInfo.length === 0
  ) {
    return 0; // Default to 1 if the array is empty or not provided
  }

  const allSalesResultsIds = listSalesResultsInfo.map(
    (item) => item.salesResultsId
  );
  return Math.max(...allSalesResultsIds) || 0;
};

function detailIsEmpty(detail) {
  return (
    (detail.rankId === 0 || isNullEmpty(detail.rankId)) &&
    (detail.productClassId === 0 || isNullEmpty(detail.productClassId)) &&
    (detail.packingId === 0 || isNullEmpty(detail.packingId)) &&
    (detail.weight === 0 || isNullEmpty(detail.weight)) &&
    (detail.quantity === 0 || isNullEmpty(detail.quantity)) &&
    (detail.purchacePrice === 0 || isNullEmpty(detail.purchacePrice))
  );
}
function resultsIsEmpty(result) {
  return (
    (result.buyerNo === 0 || isNullEmpty(result.buyerNo)) &&
    (result.quantity === 0 || isNullEmpty(result.quantity)) &&
    (result.salesDetailNo === 0 || isNullEmpty(result.salesDetailNo)) &&
    (result.unitPrice === 0 || isNullEmpty(result.unitPrice)) &&
    (result.containerQuantity === 0 || isNullEmpty(result.containerQuantity)) &&
    (result.remarks === '' || isNullEmpty(result.remarks))
  );
}
export {
  initialSalesRecord,
  initialSalesDetail,
  initialSalesResults,
  initialSalesDetails,
  initialSalesResultses,
  SALES_DETAIL_ROW_COUNT,
  SALES_RESULTS_ROW_COUNT,
  getMaxSalesDetailId,
  getMaxSalesDetailNo,
  getMaxSalesResultsId,
  resultsIsEmpty,
  detailIsEmpty,
};
